import {
  Button, Divider, Flex, Space, Typography
} from "antd";
import {
  DownOutlined, EditOutlined, UpOutlined
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import InvoiceDataForm from "../../InvoiceDataForm";
import usePatientPayments from "./usePatientPayments";
import InvoiceHistory from "../../InvoiceHistory";

const { Title, Text } = Typography;

const PatientPayments = () => {
  const { t } = useTranslation();
  const {
    form,
    handleSubmit,
    isEditing,
    toggleEdit,
    isFormEditLoading,
    billingAddress,
    handleLoadMore,
    fullName,
    invoiceData,
    defaultPageSize,
    currentPageSize
  } = usePatientPayments();

  return !isEditing
    ? (
      <>
        <Flex vertical align="start" gap={24}>
          <Title level={4} style={{ marginBottom: 0 }}>{t("settingsPage.payment.dataTitle")}</Title>
          <Flex vertical gap={24}>
            <Space size={24}>
              <Text type="secondary" strong>{t("settingsPage.payment.nameLabel")}</Text>
              <Text>{fullName}</Text>
            </Space>

            {!billingAddress ? null : (
              <Space size={24}>
                <Text type="secondary" strong>{t("settingsPage.payment.addressLabel")}</Text>
                <Text>{billingAddress}</Text>
              </Space>
            )}
          </Flex>
          <Button type="text" icon={<EditOutlined />} onClick={toggleEdit} style={{ padding: 4, height: "auto" }}>
            {t("global.button.edit")}
          </Button>
        </Flex>
        <Divider style={{ margin: "16px 0" }}/>
        <Title level={4} style={{ marginBottom: 4 }}>{t("settingsPage.payment.invoicesTitle")}</Title>
        <InvoiceHistory size={currentPageSize} invoiceData={invoiceData} />
        {invoiceData.length > defaultPageSize && (
        <Button
          type="text"
          size="small"
          icon={invoiceData.length > currentPageSize ? <DownOutlined /> : <UpOutlined />}
          onClick={handleLoadMore}
          style={{
            padding: 4, height: "auto", opacity: ".45", fontWeight: "bold"
          }}
        >
            {invoiceData.length > currentPageSize ? t("global.button.seeMore") : t("global.button.seeLess")}
        </Button>
        )}
      </>
    )
    : (
      <Flex vertical>
        <InvoiceDataForm form={form} handleSubmit={handleSubmit} />
        <Flex justify="end" gap={16}>
          <Button onClick={toggleEdit}>
            {t("global.button.cancel")}
          </Button>
          <Button
            type="primary"
            onClick={() => form.submit()}
            loading={isFormEditLoading}
            disabled={isFormEditLoading}
          >
            {t("settingsPage.payment.submitButton")}
          </Button>
        </Flex>
      </Flex>
    );
};

export default PatientPayments;
